<template>
	<div class="basic_wrap">
		<div class="login_bg"></div>
		<div class="top">
			<div class="top1">
				<span>{{name}}</span>
				<div class="language" @click="$router.push('/language')">
					<img :src="require('../images/language/'+lang+'.png')" style="width: 30px;height: 30px;">
				</div>
			</div>

		</div>
		
		
		<form class="form">
			<div class="item mt">
				<div class="">
<!--					                    <van-icon name="phone-o" />-->
					<div style="display: flex; align-items: center;" @click="areaShow = true">
						<span>+{{ data.optionval }}</span>
						<van-icon style="margin-left: 8px;" name="arrow-down" size="14"/>
					</div>
				</div>
				<input 
					type="text"
					class="inp"
					maxlength="11"
					v-model.trim="data.username"
					:placeholder="$t('userSet.phone')"
				/>
			</div>
			<div class="item">
				<span class="icon"><img src="../../assets/img/pwd.png" alt=""/></span>
				<input
					:type="password"
					class="inp"
					v-model.trim="data.password"
					:placeholder="$t('login.password')"
				/>
				<div
					class="eye_bi"
					@click="showPwd"
					:class="password == 'text' ? 'eye' : ''"
				></div>
			</div>
			
		</form>
		<div
			type="submit"
			class="basic_btn sbtn"
			:class="
                data.username == '' || data.password == '' ? 'no_touch' : ''
            "
			@click="submit"
		>
			{{ $t('login.signInBtn') }}
		</div>
		<div class="tips" @click="$router.push('/register')">{{ $t('register.signUpBtn') }}</div>
		
		<div class="tips" > 后台系统TG：anons123x</div>
		
		
		
		<van-action-sheet v-model="areaShow">
			<div class="area-content">
				<div class="area-search">
					<van-icon name="search" size="20" color="#bbbcc1"/>
					<input v-model="searchCode" class="flex-1 bg-[#f5f5f5]" type="number" :placeholder="$t('lh.搜索国家区号')">
				</div>
				<div class="area-list">
					<div class="area-item"
					     v-for="item in filterAreaList"
					     @click="selectArea(item)"
					>{{ item.name }}(+{{ item.mobilePrefix }})
					</div>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {CountDown, Checkbox} from 'vant'
import areaCode from '@/utils/areaCode';

Vue.use(Checkbox)

export default {
	name: "login",
	data() {
		return {
			
			lang: this.$i18n.locale || "zh_cn",
			password: "password",
			show_kefu: false,
			msg_show: true,
			checked: true,
			data: {
				optionval:"86",
				username: "11111111111",
				password: "123456",
			},
			title: "",
			name: "",
			areaShow: false,
			searchCode: '',
		};
	},
	created() {
		this.data.username = localStorage.getItem('login_username') || '11111111111';
		this.data.password = localStorage.getItem('login_password') || '123456';
		this.$parent.footer("user", false);
	},
	computed: {
		filterAreaList() {
			return areaCode.filter(item => item.mobilePrefix.includes(this.searchCode));
		}
	},
	mounted() {
		var that = this;
		document.body.addEventListener(
			"scroll",
			function () {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			},
			false
		);
		document.addEventListener(
			"click",
			function (ev) {
				if (ev.target.className != "kefu_img") {
					that.show_kefu = false;
				}
			},
			false
		);
		that.start();
	},

	
	methods: {
		start() {
			Fetch("/index/webconfig").then((r) => {
				this.name = r.data.web_name;
				this.title = r.data.title;
			});
			this.sync_timer = setInterval(() => {
				this.sync()
			}, 3000);
		},
		
	
		selectArea(item) {
			this.data.optionval = item.mobilePrefix;
			this.areaShow = false;
			this.searchCode = "";
		},
		kefu_to() {
			if (this.show_kefu) {
				this.$router.push("/kefu");
			}
			this.show_kefu = !this.show_kefu;
		},
		showPwd() {
			if (this.password == "password") {
				this.password = "text";
			} else {
				this.password = "password";
			}
		},
		submit() {
			if (!this.data.username) {
				this.$toast(this.$t('userSet.phone'));
				return;
			}
			
			if (!this.data.password) {
				this.$toast(this.$t('login.passwordEmpty'));
				return;
			}
			
			// var regex = /^[A-Za-z0-9]{1,20}$/;
			// if (!regex.test(this.data.username)) {
			//     this.$toast(this.$t('login.phoneError'));
			//     return;
			// }
			
			if (this.checked) {
				localStorage.setItem('login_username', this.data.username);
				localStorage.setItem('login_password', this.data.password);
			}
			
			if (!this.checked) {
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');
			}
			
			Fetch("/index/login", {
				username: this.data.username,
				password: this.data.password,
				optionval: this.data.optionval
			})
				.then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast({
						background: "#07c160",
						message: this.$t('login.signInSuccess'),
					});
				})
				.then(() => {
					this.$router.replace({
						path:
							this.$router.history.current.query.redirect || "/",
					});
				});
		},
	},
};
</script>

<style lang="less" scoped>
.area-content {
	padding-top: 1rem;
	padding-left: 1.5rem;
	padding-right: 1.5rem;
	display: flex;
	flex-direction: column;
	height: 33.333333%;
	
	.area-search {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		background-color: rgb(245 245 245);
		border-radius: 0.75rem;
		width: 100%;
		height: 2.5rem;
		display: flex;
		align-items: center;
	}
	
	.area-list {
		overflow-y: scroll;
		height: 15rem;
		
		.area-item {
			padding-top: 0.75rem;
			padding-bottom: 0.75rem;
			border-bottom-color: rgb(209 213 219);
			border-bottom-width: 1px;
			display: flex;
		}
	}
}

.basic_wrap {
	margin: 0 auto;
	width: 100%;
	height: 100vh;
	padding: 10px 24px 0 24px;
	background: url("../../assets/img/login-bg.png") no-repeat;
	background-size: 100% 100%;
	
	.top {
		color: #f0d9c3;
		
		.top1 {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 1.125rem;
			color: #ecdccf;
			margin-left: 1.15625rem;
			font-weight: 700;
		}
		
		.top2 {
			font-size: 1.05rem;
			color: #f0d9c3;
			margin-left: 2.4375rem;
			margin-top: 1.25rem;
			font-weight: 700;
		}
	}
}

.form {
	margin-top: 5.9375rem;
}

.login_bg {
	width: 100%;
	height: 60px;
	overflow: hidden;
	background-size: 100% 100%;
	
}

.language {
	width: 21px;
	height: 21px;
	
	img {
		width: 100%;
		height: 100%
	}
}


.cut_login {
	width: 207px;
	line-height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	text-align: center;
	margin: 0 auto;
	
	a {
		width: 50%;
		padding-bottom: 10px;
		color: #ceced0;
		position: relative;
		
		.line {
			width: 100%;
			height: 1px;
			position: absolute;
			left: 0;
			bottom: 0;
			background-color: #f2f2f2;
		}
	}
	
	a.cur {
		color: #f12211;
		
		.line {
			height: 2px;
			background-image: linear-gradient(to right, #f12211, #f18a11);
		}
	}
}

.mt {
	margin-top: 20px;
}

.item {
	//height: 68px;
	font-size: 14px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	//padding-bottom: 4px;
	padding: 10px 10px 4px 10px;
	background: #000000;
	border: 0.0625rem solid #514941;
	border-radius: 0.21875rem;
	color: #f0d9c3 !important;
	margin-bottom: 20px;
	
	.icon {
		width: 16px;
		height: 16px;
		
		img {
			width: 100%;
			height: 100%;
		}
	}
	
	input {
		height: 20px;
		margin-left: 7px;
		flex: 1;
		margin-bottom: 3px;
	}
}

.item_reset_pwd {
	font-size: 14px;
	color: #3d96ff;
	text-align: right;
	margin-top: 10px;
	line-height: 20px;
}

.van-checkbox {
	margin-top: 20px;
}

.reset_pwd {
	color: #3d96ff;
	margin-top: -20px;
	display: block;
}

.basic_btn {
	border-radius: 12px;
	margin: 39px auto 0 auto;
	background: linear-gradient(0deg, #AE8B6D 0%, #F1E1D3 100%);
}

.tips {
	font-size: .84375rem;
	color: #f0d9c3;
	text-align: center;
	margin-top: 1.625rem;
}
</style>
